export default {
    HEADER: 'Vlasnik kompanije',
    PLACEHOLDER_FIRST_NAME: 'Unesite ime',
    LABEL_FIRST_NAME: 'Ime',
    PLACEHOLDER_LAST_NAME: 'Unesite prezime',
    LABEL_LAST_NAME: 'Prezime',
    PLACEHOLDER_EMAIL: 'Unesite email adresu',
    LABEL_EMAIL: 'Email',
    PLACEHOLDER_ENTER_PASSWORD: 'Unesite lozinku',
    PLACEHOLDER_NEW_PASSWORD: 'Unesite novu lozinku',
    LABEL_PASSWORD: 'Lozinka',
    LABEL_NEW_PASSWORD: 'Nova lozinka',
    PLACEHOLDER_PHONE_NUMBER: 'Unesite broj telefona',
    LABEL_PHONE_NUMBER: 'Broj telefona',
};
